import React from 'react';
import { observer } from 'mobx-react';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import TechSupportComponent from './Tech-support.component';
import useTechSupport from './useTechSupport';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { lang, support, state, handlers } = useTechSupport(onClose);

    return (
        <>
            <TechSupportComponent
                lang={lang.lang}
                loading={support.loading}
                serverError={support.serverError}
                topic={state.topic}
                topicError={state.topicError}
                content={state.content}
                contentError={state.contentError}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onKeyDown={handlers.handleKeyDown}
                onKeyDownTextArea={handlers.handleKeyDownTextArea}
                onTopicChange={handlers.handleTopicChange}
                onContentChange={handlers.handleContentChange}
                onSendClick={handlers.handleSendClick}
                onInputClick={handlers.handleInputClick}
                onClose={onClose}
            />
        </>
    );
};

const TechSupportContainer = observer(Container);

export default TechSupportContainer;
